import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "@shared/shared.module";

import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";

import { routing } from "./visitas.routing";
import { RootComponent } from "./root/root.component";
import { VisitaHomeComponent } from "./pages/home/home.component";
import { HistoricoComponent } from "./pages/historico/historico.component";
import { ControleComponent } from "./pages/controle/controle.component";
import { ProximosComponent } from "./pages/proximos/proximos.component";
import { CadastroComponent } from "./pages/cadastro/cadastro.component";
import { EdicaoComponent } from "./pages/edicao/edicao.component";
import { ModalOutrasInfoComponent } from './components/modal-outras-info/modal.outras.info';

import { VisitasService } from "./services/visitas.service";

import { AuthGuard } from "@core/guards/auth.guard";
import { VendedoresSemAgendamentoComponent } from './pages/vendedores-sem-agendamento/vendedores-sem-agendamento.component';
import { VisitsImportantInfoComponent } from './pages/cadastro/modals/visits-important-info/visits-important-info.component';
import { DebitoAbertoInformacaoComponent } from './pages/cadastro/modals/debito-aberto-informacao/debito-aberto-informacao.component';
import { DebitoAbertoCarteiraInfoComponent } from './pages/cadastro/modals/debito-aberto-carteira-info/debito-aberto-carteira-info.component';
import { VendedorComAgendamentoComponent } from './pages/vendedor-com-agendamento/vendedor-com-agendamento.component';
import { StatusSemAgendamentoComponent } from './pages/status-sem-agendamento/status-sem-agendamento.component';
import { ControleClienteAtivoSemanaComponent } from './pages/controle-cliente-ativo-semana/controle-cliente-ativo-semana.component';
import { ControleFeriadoComponent } from "./pages/controle-feriado/controle-feriado.component";
import { HistoricoReagendamentoComponent } from "./pages/historico-reagendamento/historico-reagendamento.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    routing,
    SharedModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    })
  ],
  declarations: [
    RootComponent,
    VisitaHomeComponent,
    HistoricoComponent,
    ControleComponent,
    ProximosComponent,
    CadastroComponent,
    EdicaoComponent,
    ModalOutrasInfoComponent,
    VendedoresSemAgendamentoComponent,
    VisitsImportantInfoComponent,
    DebitoAbertoInformacaoComponent,
    DebitoAbertoCarteiraInfoComponent,
    VendedorComAgendamentoComponent,
    StatusSemAgendamentoComponent,
    ControleClienteAtivoSemanaComponent,
    ControleFeriadoComponent,
    HistoricoReagendamentoComponent,
  ],
  providers: [AuthGuard, VisitasService]
})
export class VisitasModule {}
